<template>
  <div class="koc-block koc-auth-register-block">
    <div class="koc-half">
      <form-input-component
        name="firstname"
        type="text"
        label="First Name"
        @update="update"
      />
    </div>
    <div class="koc-half">
      <form-input-component
        name="lastname"
        type="text"
        label="Last Name"
        @update="update"
      />
    </div>
    <div class="koc-half">
      <form-input-component
        name="email"
        type="text"
        label="Email"
        @update="update"
      />
    </div>
    <div class="koc-half">
      <form-input-component
        name="username"
        type="text"
        label="Username"
        @update="update"
      />
    </div>
    <div class="koc-half">
      <form-input-component
        name="password"
        :type="state.showPassword ? 'text' : 'password'"
        label="Password"
        :value="state.password"
        @update="update"
      />
    </div>
    <div class="koc-half">
      <form-input-component
        name="confirm"
        :type="state.showPassword ? 'text' : 'password'"
        label="Confirm Password"
        :value="state.confirm"
        @update="update"
      />
      <div
        v-if="state.mismatch"
        class="koc-error koc-full"
      >
        Confirm Password doesn't match Password
      </div>
      <button
        v-if="state.mismatch"
        class="koc-toggle-password koc-button koc-ripple"
        @click="togglePassword"
      >
        <span v-if="state.showPassword">Hide</span>
        <span v-if="!state.showPassword">Show</span>
      </button>
    </div>
    <div class="koc-submit koc-flex-fullwidth-row koc-flex-center koc-flex-wrap">
      <button
        class="koc-button koc-ripple"
        :disabled="!state.canSubmit"
        @click="register"
      >
        Create Account
      </button>
      <span class="koc-auth-register-login-link-span">Have a KelbyOne Member account? <a
        class="koc-link koc-title"
        @click="login"
      >LOG IN</a> using those credentials.</span>
    </div>
  </div>
</template>

<script src="./register.js"></script>
<style lang="scss" scoped src="./register.scss"></style>
